import { common } from './pl/common';

export const pl = {
  common,
};